export default __webpack_public_path__ + "static/media/04_GIF.6e2b2b20.gif";